/**
 * Warning!!!! Changing this and adding a non-null value could break existing
 * records, please proceed with caution, this is basically the source of truth
 * for applicationUserEvent's json
 *
 */ export var PaywallAssignedInitiator = /*#__PURE__*/ function(PaywallAssignedInitiator) {
    PaywallAssignedInitiator["Unknown"] = "unknown";
    PaywallAssignedInitiator["FirstAssignment"] = "first_assignment";
    return PaywallAssignedInitiator;
}({});
 // export type ApplicationUserEventType = {
 // } ;
